import { defineComponent as _defineComponent } from 'vue'
import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';

import { CollectionType } from '@/enums/collection-type';
import { useFilterStore } from '@/helpers/composables/useStores';
import { TitleObjectType } from '@/interfaces/titles';

import type { GetOrderedSubgenresQuery } from '@/pages/graphql/queries/GetSubgenres.query';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterBarSubgenrePills',
  props: {
    orderedSubgenres: null,
    subgenresList: null
  },
  setup(__props: any) {

const props = __props as {
	orderedSubgenres: GetOrderedSubgenresQuery['genres'];
	subgenresList: GetOrderedSubgenresQuery['subgenres'];
};



const { filters, toggle } = useFilterStore();

// show genre breadcrumb-style text before pills, if subgenre filter active, else if one genre filter active
const genreGroup = computed(() => {
	if (
		activeContentType.value.length !== 1 ||
		(activeSubgenreFilter.value.length === 0 && activeGenresFilter.value.length !== 1)
	)
		return '';

	if (activeSubgenreFilter.value.length === 1)
		return props.orderedSubgenres.find(group =>
			group['subgenreMovies'].find(subgenre => subgenre.content.shortName === activeSubgenreFilter.value[0])
		)?.translation;
	else if (isSingleGenreWithSubgenres.value)
		return props.orderedSubgenres.find(group => group.shortName === activeGenresFilter.value[0])?.translation;

	return '';
});

const isSingleGenreWithSubgenres = computed(() => {
	//only show genreGroup > pills when genre has subgenres. Currently 3 or 4 genres have no subs.
	return (
		activeGenresFilter.value.length > 0 &&
		props.orderedSubgenres.find(
			group =>
				group.shortName === activeGenresFilter.value[0] &&
				group.subgenreMovies.length > 0 &&
				group.subgenreShows.length > 0
		)
	);
});

const orderedSubgenreByShow = computed(() => {
	return props.orderedSubgenres
		.find(group =>
			group.subgenreShows.find(subgenre => subgenre.content.shortName === activeSubgenreFilter.value[0])
		)
		?.subgenreShows.map(sub => sub.content);
});

const orderedSubgenreByMovie = computed(() => {
	return props.orderedSubgenres
		.find(group =>
			group.subgenreShows.find(subgenre => subgenre.content.shortName === activeSubgenreFilter.value[0])
		)
		?.subgenreMovies.map(sub => sub.content);
});
const orderedSubgenresByShowAndGenre = computed(() => {
	return props.orderedSubgenres
		.find(group => group.shortName === activeGenresFilter.value[0])
		?.subgenreShows.map(sub => sub.content);
});

const orderedSubgenresByMovieAndGenre = computed(() => {
	return props.orderedSubgenres
		.find(group => group.shortName === activeGenresFilter.value[0])
		?.subgenreMovies.map(sub => sub.content);
});

const orderedPillsMoviesNoFilters = computed(() => {
	return props.subgenresList
		.map(sub => sub.content)
		.filter(sub => sub.moviesUrl && sub.moviesUrl.fullPath !== null)
		.slice(0, 18);
});

const orderedPillsShowsNoFilters = computed(() => {
	return props.subgenresList
		.map(sub => sub.content)
		.filter(sub => sub.showsUrl && sub.showsUrl.fullPath !== null)
		.slice(0, 18);
});

const orderedPills = computed(() => {
	if (
		activeContentType.value.length === 0 ||
		(activeSubgenreFilter.value.length === 0 && activeGenresFilter.value.length > 1)
	)
		return [];

	// if single subgenre, show  pills by subgenre (related subs) and content. else if genre, show pills by genre and content.
	// if no filters, or multiple filters, show order by SV. hardcoded values to be replaced by BE.
	if (isShowsFiltered.value) {
		if (activeSubgenreFilter.value.length > 0) return orderedSubgenreByShow.value;
		else if (activeGenresFilter.value.length === 1) {
			return isSingleGenreWithSubgenres.value ? orderedSubgenresByShowAndGenre.value : '';
		}

		return orderedPillsShowsNoFilters.value;
	}

	if (isMoviesFiltered.value) {
		if (activeSubgenreFilter.value.length > 0) {
			return orderedSubgenreByMovie.value;
		} else if (activeGenresFilter.value.length === 1) {
			return isSingleGenreWithSubgenres.value ? orderedSubgenresByMovieAndGenre.value : '';
		} else {
			return orderedPillsMoviesNoFilters.value;
		}
	}
	return [];
});

const activeContentType = computed(() => {
	return filters.value(CollectionType.POPULAR)['content_types'] as string[];
});

const isMoviesFiltered = computed(() => {
	return activeContentType.value.includes(TitleObjectType.MOVIE);
});

const isShowsFiltered = computed(() => {
	return activeContentType.value.includes(TitleObjectType.SHOW);
});

const activeSubgenreFilter = computed(() => {
	return filters.value(CollectionType.POPULAR).subgenres as string[];
});

const activeGenresFilter = computed(() => {
	return filters.value(CollectionType.POPULAR).genres as string[];
});

const isActive = (subgenreShortName: string) =>
	((filters.value(CollectionType.POPULAR).subgenres as string[]) ?? []).some(
		subgenre => subgenre === subgenreShortName
	);

const subgenreClicked = (subgenreShortName: string) => {
	toggle({
		filterName: 'subgenres',
		value: subgenreShortName,
		selectedState: isActive(subgenreShortName) ? 0 : 1,
	});
};

return { __sfc: true,props, filters, toggle, genreGroup, isSingleGenreWithSubgenres, orderedSubgenreByShow, orderedSubgenreByMovie, orderedSubgenresByShowAndGenre, orderedSubgenresByMovieAndGenre, orderedPillsMoviesNoFilters, orderedPillsShowsNoFilters, orderedPills, activeContentType, isMoviesFiltered, isShowsFiltered, activeSubgenreFilter, activeGenresFilter, isActive, subgenreClicked, HiddenHorizontalScrollbar }
}

})